import { render } from "./AgenteActas.vue?vue&type=template&id=bfaafaec&scoped=true"
import script from "./AgenteActas.vue?vue&type=script&lang=ts"
export * from "./AgenteActas.vue?vue&type=script&lang=ts"

import "./AgenteActas.vue?vue&type=style&index=0&id=bfaafaec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bfaafaec"

export default script